import { render, staticRenderFns } from "./lkuDepartment.vue?vue&type=template&id=6ade8ec1&"
import script from "./lkuDepartment.vue?vue&type=script&lang=js&"
export * from "./lkuDepartment.vue?vue&type=script&lang=js&"
import style0 from "./lkuDepartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports